'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = getGlobalBoundingClientRect;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodashCollectionFindWhere = require('lodash/collection/findWhere');

var _lodashCollectionFindWhere2 = _interopRequireDefault(_lodashCollectionFindWhere);

function getGlobalBoundingClientRect(de) {
  var _de$getBoundingClientRect = de.getBoundingClientRect();

  var top = _de$getBoundingClientRect.top;
  var left = _de$getBoundingClientRect.left;
  var width = _de$getBoundingClientRect.width;
  var height = _de$getBoundingClientRect.height;

  function check(deCheck) {
    var ownerDocument = deCheck.ownerDocument;

    if (ownerDocument !== document) {
      var parentDocument = ownerDocument.defaultView.parent.document;
      var iframes = parentDocument.querySelectorAll('iframe');
      var iframe = (0, _lodashCollectionFindWhere2['default'])(iframes, { contentDocument: ownerDocument });
      if (iframe) {
        var brIframe = iframe.getBoundingClientRect();
        left += brIframe.left;
        top += brIframe.top;
      }
    }
  }

  check(de);

  return { top: top, left: left, width: width, height: height };
}

module.exports = exports['default'];
//# sourceMappingURL=getGlobalBoundingClientRect.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/transhand/lib/getGlobalBoundingClientRect.js
 ** module id = 3290
 ** module chunks = 0
 **/